import React from 'react'
import PropTypes from 'prop-types'
import { AppliedDiscountCodeType, BillingType } from 'types'
import { calculatePaymentAmount, formatCurrency } from 'utils'

const propTypes = {
  billing: BillingType,
  discountCodeDetails: AppliedDiscountCodeType,
  isTrialMembershipsActive: PropTypes.bool,
  membershipType: PropTypes.string,
  promoCodeIsTrial: PropTypes.bool,
  trialDuration: PropTypes.number,
}

function OrderSummary({
  billing,
  discountCodeDetails,
  isTrialMembershipsActive,
  membershipType,
  promoCodeIsTrial,
  trialDuration,
}) {
  const {
    finalDonation = 0,
    originalMembershipCost = 0,
    discountedMembershipCost = 0,
    referralCreditsUsed = 0,
    subtotalWithoutDonations = 0,
    trailerCareCost = 0,
    trailerCareDetail = {},
  } = billing || {}

  const isTrial = promoCodeIsTrial && isTrialMembershipsActive
  const hasDiscount = discountCodeDetails && !isTrial
  const hasTrailerCare = trailerCareCost > 0
  const hasDonation = finalDonation > 0

  const membershipLabel = isTrial
    ? `${membershipType} - ${trialDuration} days`
    : `${membershipType} Membership`

  const membershipPrice = isTrial
    ? formatCurrency(0)
    : formatCurrency(originalMembershipCost)

  const discountSummary = hasDiscount && (
    <div className="invoice-item confirmation-item">
      <img src="/assets/images/imagery/ST_Icon_discount.svg" alt="" />
      <p className="title">{`${discountCodeDetails.type.toUpperCase()}: ${discountCodeDetails.name}`}</p>
      <div className="cost">
        <p>
          {discountCodeDetails.dollarsOff > 0 &&
            `${formatCurrency(-discountCodeDetails.dollarsOff)}`}
          {discountCodeDetails.percentOff > 0 &&
            ` (${discountCodeDetails.percentOff}%)`}
        </p>
      </div>
    </div>
  )

  const trailerCareSummary = hasTrailerCare && (
    <div className="invoice-item confirmation-item">
      <img src="/assets/images/imagery/ST_Icon_trailer-care.svg" alt="" />
      <p className="title">{trailerCareDetail.marketingTitle}</p>
      <div className="cost">
        <p>{formatCurrency(trailerCareCost)}</p>
      </div>
    </div>
  )

  const donationSummary = hasDonation && (
    <div className="invoice-item confirmation-item">
      <img src="/assets/images/imagery/ST_Icon_donation.svg" alt="" />
      <p className="title">Sea Tow Foundation Donation</p>
      <div className="cost">
        <p>{formatCurrency(finalDonation)}</p>
      </div>
    </div>
  )

  const totalCost = formatCurrency(
    calculatePaymentAmount({
      discountedMembershipCost,
      referralCreditsUsed,
      subtotal: subtotalWithoutDonations,
      donationAmount: finalDonation,
    }),
  )

  return (
    <div className="invoice-summary group-block">
      <h3 className="group-title">Order Summary</h3>

      <div className="invoice-item confirmation-item">
        <img src="/assets/images/imagery/ST_Icon_membercard.svg" alt="" />
        <p className="title">{membershipLabel}</p>
        <div className="cost">
          <p>{membershipPrice}</p>
        </div>
      </div>

      {discountSummary}
      {trailerCareSummary}
      {donationSummary}

      <div className="invoice-item total confirmation-item">
        <p className="title">Total:</p>
        <p className="cost">{totalCost}</p>
      </div>
    </div>
  )
}

OrderSummary.propTypes = propTypes

export default OrderSummary
